import { Model, MapTo } from 'src/app/decorators/mapto';

export class CountriesModel extends Model {
    @MapTo()
    id: number;
    @MapTo()
    name: string;
    @MapTo()
    sort_name: string;
    @MapTo()
    phone_code: string;

    constructor(payload: any) {
        super(payload);
        this.setValues(payload);
    }
}
